import { fromMarkdown } from "mdast-util-from-markdown";
import { toString } from "mdast-util-to-string";

export const formatToText = (value = "") => {
  if (typeof value === "string") {
    return toString(fromMarkdown(value.replaceAll("\n", " ")));
  }
  return "";
};
